import {FormSessionDto} from "../../client/formsession/FormSessionApiClient";

export type RowId = string | number;

export function getUniqueId(row: FormSessionDto): RowId {
    return JSON.stringify(row);
}

export function findFormSessionById(formSessionId: RowId): Promise<FormSessionDto> {
    return new Promise((resolve, reject) => {
        resolve(JSON.parse("" + formSessionId));
    })
}
